import Icon from './icon/index.js'

function install(Vue, opts = []) {
  let isWeb = false
  let isWxmp = false
  // #ifdef H5
  isWeb = true
  // #endif

  // #ifdef MP-WEIXIN
  isWxmp = true
  // #endif

  if (isWeb) {
    if (opts.length > 0) {
      opts.forEach((v) => {
        v = v.toLocaleLowerCase()
        if (!document.getElementById(`${v}-icon`)) {
          const script = document.createElement('script')
          script.type = 'text/javascript'
          script.id = `${v}-icon`
          script.setAttribute(
            'src',
            `https://front-end-huawei-cdn.devops.cndinfo.com/npm/@cndinfo/cube-design-icons/0.2.0/symbol/${v}-icons.js`
          )
          document.head.appendChild(script)
        }
      })
    } else {
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.id = `icon`
      script.setAttribute(
        'src',
        `https://front-end-huawei-cdn.devops.cndinfo.com/npm/@cndinfo/cube-design-icons/0.2.0/symbol/icons.js`
      )
      document.head.appendChild(script)
    }
  }

  Vue.prototype.$opts = opts
  Vue.prototype.$isWeb = isWeb
  Vue.prototype.$isWxmp = isWxmp
  Vue.use(Icon)
}

// if (window && window.Vue) {
//   Vue.use(install)
// }
/* istanbul ignore if */
// if (typeof window !== 'undefined' && window.Vue) {
//   install(window.Vue)
// }

export {
  Icon
}

export default install
